// put in separate file because of circular dependency
// this is used in meetingsUiService, which is used within MeetingTab, which uses meetingsUiService...
export const MeetingTabId = "sidebar-meeting";